module.exports = __webpack_public_path__ + "img/clayhair.223efb91.png";